export default __webpack_public_path__ + "images/YQ.d254852.png";